import { render } from "./Center.vue?vue&type=template&id=17f410ea"
import script from "./Center.vue?vue&type=script&lang=ts"
export * from "./Center.vue?vue&type=script&lang=ts"
script.render = render

export default script